"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthersContractWrapper = void 0;
var ethers_1 = require("ethers");
var typechain_1 = require("../../../typechain");
var EthersContractWrapper = /** @class */ (function () {
    function EthersContractWrapper(baseContract, apiConnector) {
        this.baseContract = baseContract;
        this.apiConnector = apiConnector;
    }
    EthersContractWrapper.prototype.finish = function () {
        var contract = this.baseContract;
        var contractPrototype = Object.getPrototypeOf(contract);
        var wrappedContract = Object.assign(Object.create(contractPrototype), contract);
        var self = this;
        var functionNames = Object.keys(contract.functions);
        functionNames.forEach(function (functionName) {
            if (functionName.indexOf("(") == -1) {
                var isCall_1 = contract.interface.getFunction(functionName).constant;
                if (functionName == "authorizeSigner") {
                    wrappedContract["authorizeProvider"] = function () {
                        return __awaiter(this, void 0, void 0, function () {
                            var signer;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, self.getSigner()];
                                    case 1:
                                        signer = _a.sent();
                                        console.log("Authorizing provider: " + signer);
                                        return [4 /*yield*/, wrappedContract.authorizeSigner(signer)];
                                    case 2: return [2 /*return*/, _a.sent()];
                                }
                            });
                        });
                    };
                }
                else {
                    wrappedContract[functionName] = function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        return __awaiter(this, void 0, void 0, function () {
                            var tx, _a, _b, result, decoded;
                            var _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0: return [4 /*yield*/, (_c = contract.populateTransaction)[functionName].apply(_c, args)];
                                    case 1:
                                        tx = _d.sent();
                                        // Here we append price data (currently with function signatures) to transaction data
                                        _a = tx;
                                        _b = tx.data;
                                        return [4 /*yield*/, self.getPriceData(contract.signer)];
                                    case 2:
                                        // Here we append price data (currently with function signatures) to transaction data
                                        _a.data = _b + (_d.sent())
                                            + self.getMarkerData();
                                        if (!isCall_1) return [3 /*break*/, 4];
                                        return [4 /*yield*/, contract.signer.call(tx)];
                                    case 3:
                                        result = _d.sent();
                                        decoded = contract.interface.decodeFunctionResult(functionName, result);
                                        return [2 /*return*/, decoded.length == 1 ? decoded[0] : decoded];
                                    case 4: return [4 /*yield*/, contract.signer.sendTransaction(tx)];
                                    case 5: return [2 /*return*/, _d.sent()];
                                }
                            });
                        });
                    };
                }
            }
        });
        return wrappedContract;
    };
    EthersContractWrapper.prototype.getSigner = function () {
        return this.apiConnector.getSigner();
    };
    EthersContractWrapper.prototype.getMarkerData = function () {
        var marker = ethers_1.ethers.utils.id("Redstone.version.0.0.1");
        return EthersContractWrapper.remove0xFromHexString(marker);
    };
    EthersContractWrapper.prototype.getPriceData = function (signer) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, priceData, signature, priceFeed, setPriceTx, setPriceData, clearPriceTx, clearPricePrefix, priceDataLen;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.apiConnector.getSignedPrice()];
                    case 1:
                        _a = _b.sent(), priceData = _a.priceData, signature = _a.signature;
                        priceFeed = typechain_1.PriceFeedWithClearing__factory.connect(ethers_1.ethers.constants.AddressZero, signer);
                        return [4 /*yield*/, priceFeed.populateTransaction.setPrices(priceData, signature)];
                    case 2:
                        setPriceTx = _b.sent();
                        // not sure about this?
                        if (setPriceTx.data === undefined) {
                            throw new Error("setPriceTx data not set");
                        }
                        setPriceData = EthersContractWrapper.remove0xFromHexString(setPriceTx.data);
                        return [4 /*yield*/, priceFeed.populateTransaction.clearPrices(priceData)];
                    case 3:
                        clearPriceTx = _b.sent();
                        clearPricePrefix = clearPriceTx.data ? clearPriceTx.data.substr(2, 8) : "";
                        priceDataLen = EthersContractWrapper.countBytesInHexString(setPriceData);
                        // Template of data that we add to the end of tx is below
                        // [SIG_CLEAR|4][SIG_SET|4][DATA|...][DATA_LEN|2][MARKER|32]
                        // - SIG_CLEAR (4 bytes) - signature of clearPrices method of PriceFeed contract
                        // - SIG_SET (4 bytes) - signature of setPrices method of PriceFeed contract
                        // TODO: shouldn't the DATA_LEN be before DATA?
                        // - DATA (variable bytes size) - pricing data
                        // - DATA_LEN (2 bytes) - pricing data size (in bytes)
                        // - MARKER (32 bytes) - redstone marker
                        return [2 /*return*/, clearPricePrefix + setPriceData + priceDataLen.toString(16).padStart(4, "0")]; // padStart helps to always have 2 bytes length for any number
                }
            });
        });
    };
    EthersContractWrapper.countBytesInHexString = function (hexStringWithout0x) {
        return hexStringWithout0x.length / 2;
    };
    EthersContractWrapper.remove0xFromHexString = function (hexString) {
        if (!(hexString === null || hexString === void 0 ? void 0 : hexString.toLowerCase().startsWith("0x"))) {
            return hexString;
        }
        return hexString.substr(2);
    };
    return EthersContractWrapper;
}());
exports.EthersContractWrapper = EthersContractWrapper;
//# sourceMappingURL=EthersContractWrapper.js.map